import { Navigate, useRoutes } from 'react-router-dom';

import { AuthGuard, GuestGuard } from 'src/auth/guard';
import AuthClassicLayout from 'src/layouts/auth/classic';
import AppLayout from 'src/layouts/app/layout';

import LoginPage from 'src/pages/auth/login';
import RegisterPage from 'src/pages/auth/register';
import OAuthCallbackPage from 'src/pages/auth/oauth-callback';
import FilingsListPage from 'src/pages/filings/list';
import CurrentFilingPage from 'src/pages/filings/current';
import FilingWizardPage from 'src/pages/filings/wizard';
import FilingReportPage from 'src/pages/filings/report';
import PaymentReturnPage from 'src/pages/filings/payment-return';
import NotFoundPage from 'src/pages/not-found';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    { path: '/', element: <Navigate to="/filings" replace /> },
    {
      path: 'auth',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <AuthClassicLayout>
                <LoginPage />
              </AuthClassicLayout>
            </GuestGuard>
          ),
        },
        {
          path: 'register',
          element: (
            <GuestGuard>
              <AuthClassicLayout>
                <RegisterPage />
              </AuthClassicLayout>
            </GuestGuard>
          ),
        },
        { path: 'callback', element: <OAuthCallbackPage /> },
      ],
    },
    {
      path: 'filings',
      element: (
        <AuthGuard>
          <AppLayout />
        </AuthGuard>
      ),
      children: [
        { element: <FilingsListPage />, index: true },
        { path: 'current', element: <CurrentFilingPage /> },
        { path: ':id', element: <FilingWizardPage /> },
        { path: ':id/report', element: <FilingReportPage /> },
        { path: ':id/payment/success', element: <PaymentReturnPage mode="success" /> },
        { path: ':id/payment/cancel', element: <PaymentReturnPage mode="cancel" /> },
      ],
    },
    { path: '*', element: <NotFoundPage /> },
  ]);
}
